import { connect } from "react-redux";
import { compose } from "recompose";
import { firestoreConnect, isLoaded } from "react-redux-firebase";
import SchedulerForm from "components/Scheduler/SchedulerForm";
import { createScheduler } from "actions/scheduler/schedulerActions";
import * as routes from "constants/routes";

const handleFormSubmit = props => formValues => {
  formValues.date.setTime(formValues.time.getTime())
  // console.log("form values",formValues.date)

  return props.createScheduler(formValues).then(() => {
    props.history.push(routes.SCHEDULER);
  });
};

const mapStateToProps = (state, ownProps) => {
  const { firestore, firebase } = state;

  const customers = firestore.ordered.customers;
  const regions = firestore.ordered.regions;
  const equipments = firestore.ordered.equipments;
  const agreements = firestore.ordered.agreements;
  const date = firestore.ordered.date;
  const time = firestore.ordered.time;
  const repeat = firestore.ordered.repeat;

  const auth = firebase.auth;
  const { error } = state.notifications;

  const initialValues = {
    customerId: "*",
    regionId: "*",
    equipmentId: "*",
    agreementId: "*",
    date:new Date(),
    time:new Date(),
    repeat:"norepeat"
  };
  const formInitValues = { customers, regions, equipments, agreements };

  const isLoading =
    !isLoaded(customers) &&
    !isLoaded(regions) &&
    !isLoaded(equipments) &&
    !isLoaded(agreements);

  return {
    isLoading: isLoading,
    initialValues: initialValues,
    formInitValues: formInitValues,
    onSubmit: handleFormSubmit(ownProps),
    isEditing: false,
    auth: auth,
    error: error,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createScheduler: formValues => dispatch(createScheduler(formValues)),
  };
};

export default compose(
  firestoreConnect([
    { collection: "customers" },
    { collection: "equipments" },
    { collection: "regions" },
    { collection: "agreements" },
  ]),
  connect(
    null,
    mapDispatchToProps
  ),
  connect(mapStateToProps),
)(SchedulerForm);
